module.exports = __webpack_public_path__ + "static/media/computer-image.728fca35.png";